module.exports = __webpack_public_path__ + "img/platine_pique.946e34ff.jpeg";